module.exports = __webpack_public_path__ + "img/mv.d50b2004.svg";